import React from 'react'

export function OnlinePaymentRegisterDetail() {
    return (

        <div className="container-fluid">
            <div className="white_box h-100">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="row">
                            <div className="col-md-12 my-4">
                                <h3 className="mb-3 d-flex align-items-center"><b>OnlinePaymentRegister ID - 000771/130421/US  </b> <img className="shareicon" src="/admin/assets/images/share_icon.svg" height="20" alt='share-icon' /></h3>
                                <p className="text-muted">Advance paid - 0.00 AED</p>
                            </div>

                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-lg-12 col-md-6">
                                        <div className="card p-3">
                                            <div className="row">
                                                <div className="col-lg-3 col-md-4 border-end">
                                                    <div className="iconImg my-3">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person" viewBox="0 0 16 16">
                                                            <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                                                        </svg>
                                                    </div>
                                                    <h5 className="mb-0">Customer Name</h5>
                                                    <p>Gateway - Telr Gateway</p>
                                                    <p className="mb-0">Amount Paid</p> <h3 className="mb-0">AED 6598.00 <small className="text-muted h6 text-right">Advance</small></h3>
                                                </div>


                                                <div className="col-lg-8 ps-md-4 col-md-6">

                                                    <table width="100%">
                                                        <tbody>
                                                            <tr>
                                                                <td className="py-1" style={{ width: 150 }}>Date of Receipt </td>
                                                                <td>-</td>
                                                                <td className="py-1">20 July, 2021</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="py-1">Receipt Ref</td>
                                                                <td>-</td>
                                                                <td className="py-1">#51521326</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="py-1">Gateway Ref </td>
                                                                <td>-</td>
                                                                <td className="py-1">S20PAY14APR202165252</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="py-1">Booking Ref#</td>
                                                                <td>-</td>
                                                                <td className="py-1">#25652652632</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="py-1">Invoice Ref# </td>
                                                                <td>-</td>
                                                                <td className="py-1">#25652652632</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="py-1">Status</td>
                                                                <td>-</td>
                                                                <td> <span className="badge rounded-pill font-size-12 pointer bg-success">Successful</span> </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="py-1">Post to FA</td>
                                                                <td>-</td>
                                                                <td className="py-1">
                                                                    <span className="badge rounded-pill font-size-12 pointer bg-warning">Pending</span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div >
                </div >
            </div >
        </div >
    )
}



